import type { ExternalTableSchema } from '@packages/table-builder';

export const vestingTemplatesTable: ExternalTableSchema = {
  metadata: {
    title: 'Vesting Templates',
    entity: 'VestingTemplate',
    description: 'Current list of default and custom vesting templates.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/vesting-template/vesting-template-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      VestingTypeIds: 'filters.VestingTypeIds',
    },
    filters: [
      {
        name: 'VestingTypeIds',
        placeholder: 'Vesting Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/vesting-type/vesting-types',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'createdDate',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 200,
    },
    {
      field: 'name',
      header: 'Vesting Template Name',
      type: 'modal',
      sortable: true,
      width: 300,
      fields: {
        excludeKey: 'vestingType',
        excludeValue: ['Specific Vesting'],
      },
      modal: {
        popoverInfo: { id: 'vestingTemplateNamePopover' },
      },
    },
    {
      field: 'vestingType',
      header: 'Vesting Type',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      uppercase: true,
      badge: {
        statusMap: {
          'Cliff Vesting': 'success',
          'Step Vesting': 'info',
          'Hybrid Vesting': 'warning',
          'Specific Vesting': 'success',
          'Custom Vesting Tranche': 'success',
          Cliff: 'success',
          Step: 'info',
          Hybrid: 'warning',
          Specific: 'success',
          Custom: 'success',
        },
        displayMap: {
          'Cliff Vesting': 'CLIFF',
          'Step Vesting': 'STEP',
          'Specific Vesting': 'SPECIFIC',
          'Custom Vesting Tranche': 'CUSTOM',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'lengthInMonths',
      header: 'Full Vesting Period',
      type: 'custom',
      renderer: 'vestingTemplateLengthMonths',
      sortable: true,
      width: 200,
      align: 'center',
      fields: {
        concatText: 'Months',
      },
    },
    {
      field: 'vestsAfterInMonths',
      header: 'Vesting Start Delay Months',
      type: 'number',
      sortable: true,
      width: 200,
      align: 'center',
      visibility: 'picker',
      fields: {
        concatText: 'Months',
      },
    },
    {
      field: 'vestsInMonths',
      header: 'Vesting Duration Months',
      type: 'number',
      sortable: true,
      width: 200,
      align: 'center',
      visibility: 'picker',
      fields: {
        concatText: 'Months',
      },
    },
    {
      field: 'intervalInMonths',
      header: 'Vesting Interval Months',
      type: 'number',
      sortable: true,
      width: 200,
      align: 'center',
      visibility: 'picker',
      fields: {
        concatText: 'Months',
      },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_VESTING_TEMPLATES', label: 'View' },
      { id: 'EDIT_VESTING_TEMPLATES', label: 'Edit' },
      { id: 'COPY_VESTING_TEMPLATES', label: 'Copy' },
      { id: 'PREVIEW_VESTING_TEMPLATES', label: 'Preview' },
      { id: 'DELETE_VESTING_TEMPLATES', label: 'Delete', variant: 'danger' },
    ],
    bulk: [{ id: 'BULK_EXPORT_VESTING_TEMPLATES', label: 'Bulk Export', icon: 'download' }],
    toolbar: {
      primary: {
        id: 'ADD_VESTING_TEMPLATES',
        label: 'Add Template',
        icon: 'add_circle_outline',
      },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_VESTING_TEMPLATES', label: 'Download Template' }],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [{ id: 'IMPORT_VESTING_TEMPLATES', label: 'Import Bulk XLS' }],
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    selection: { keyField: 'id', selectAllPages: true },
    columnPreferences: { persistenceKey: 'Vesting Template', resizable: true, reorderable: true },
  },
};
